<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="salaryReceiptEditDialog"
    :title="$t('salary_management.edit_payment')"
    :confirm-text="$t('common.save')"
    confirm-variant="primary"
    size="lg"
    @confirm="handleConfirm"
  >
    <template #body>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.receipt_no') }}</label>
          <input class="form-control" :value="receipt?.receipt_no || 'N/A'" disabled />
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.employee') }}</label>
          <input class="form-control" :value="receipt?.model_name || '—'" disabled />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.payment_type') }} *</label>
          <select class="form-select" v-model="formData.type" :class="{ 'is-invalid': errors.type }" required>
            <option value="salary">{{ $t('salary_management.salary') }}</option>
            <option value="on_account">{{ $t('salary_management.on_account') }}</option>
            <option value="reward">{{ $t('salary_management.reward') }}</option>
            <option value="deduction">{{ $t('salary_management.deduction') }}</option>
          </select>
          <div class="invalid-feedback">{{ errors.type }}</div>
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.value') }} *</label>
          <input type="number" step="0.01" class="form-control"
                 v-model.number="formData.value" :class="{ 'is-invalid': errors.value }" required />
          <div class="invalid-feedback">{{ errors.value }}</div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.payment_date') }} *</label>
          <input type="date" class="form-control"
                 v-model="formData.payment_date" :class="{ 'is-invalid': errors.payment_date }" required />
          <div class="invalid-feedback">{{ errors.payment_date }}</div>
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.description') }}</label>
          <input class="form-control" v-model="formData.description" />
        </div>
      </div>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const emit = defineEmits(['save']);
const baseDialog = ref(null);
const receipt = ref(null);

const formData = ref({ type: 'salary', value: 0, payment_date: '', description: '' });
const errors = ref({});

const open = (r) => {
  receipt.value = r || {};
  formData.value = {
    type: r?.type || 'salary',
    value: Number(r?.value || 0),
    payment_date: r?.payment_date || new Date().toISOString().split('T')[0],
    description: r?.description || ''
  };
  errors.value = {};
  baseDialog.value?.openDialog();
};

const handleConfirm = () => {
  errors.value = {};
  if (!formData.value.type) errors.value.type = 'Required';
  if (!formData.value.value || formData.value.value <= 0) errors.value.value = 'Must be > 0';
  if (!formData.value.payment_date) errors.value.payment_date = 'Required';
  if (Object.keys(errors.value).length) return;

  emit('save', { id: receipt.value.id, ...formData.value });
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
